<template>
  <div class="departments-menu text-secondary-1 q-mx-lg q-mt-md">
    <RDropdown
      v-if="departments.length > 10"
      v-model="selectedDepartment"
      :options="[{ id: null, name: 'Total' }, ...departments]"
      label="Departments"
      option-value="id"
      option-label="name"
      style="min-width: 200px"
    />

    <template v-else>
      <span
        v-if="departments.length"
        class="text-body-1 cursor-pointer q-pa-sm"
        :class="{ 'text-body-3 text-uppercase': selectedDepartment.id === null }"
        @click="selectedDepartment = { id: null, name: 'Total' }"
      >
        Total
      </span>
      <span class="line bg-white-5"></span>

      <template v-for="(dep, index) of departments">
        <span
          :key="dep.id"
          :class="{ 'text-body-3 text-uppercase': selectedDepartment && dep.id === selectedDepartment.id }"
          class="text-body-1 cursor-pointer q-pa-sm"
          @click="selectedDepartment = dep"
        >
          {{ dep.name }}
        </span>
        <span v-if="index !== departments.length - 1" :key="`${dep.id}-line`" class="line bg-white-5"></span>
      </template>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    vuexModule: {
      type: String,
      required: true
    }
  },

  computed: {
    departments() {
      return this.$store.state.predictions.departments
    },

    selectedDepartment: {
      get() {
        const dep = this.$store.state[this.vuexModule].selectedDepartment
        return dep || { id: null, name: 'Total' }
      },

      set(newVal) {
        const dep = newVal.id === null ? null : newVal
        this.setSelectedDepartment(dep)
      }
    }
  },

  methods: {
    setSelectedDepartment(department) {
      this.$store.commit(`${this.vuexModule}/setSelectedDepartment`, department)
    }
  }
}
</script>

<style lang="scss" scoped>
.departments-menu {
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  .line {
    margin: 0 var(--r-space-sm);
  }

  .line {
    width: 1px;
    height: 13px;
  }
}
</style>
